document.addEventListener("DOMContentLoaded", function () {

  function addVendorSwatchLinks() {

    const upholsterySwatches = document.querySelectorAll(
      '.swatches div[option-name="Upholstery"]'
    );

    const vendorElement = document.querySelector('.vendor .brand');

    if (!upholsterySwatches.length || !vendorElement) return;

    const vendor = vendorElement.innerText.trim();
    const vendorText = vendor.toLowerCase();

    let pageLink = "";

    if (vendorText.includes("bauhaus")) {
      pageLink = "/pages/bauhaus-studio-swatches-to-order";
    } else if (vendorText.includes("mcm")) {
      pageLink = "/pages/mcm-house-swatches-to-order";
    } else if (vendorText.includes("camerich")) {
      pageLink = "/pages/camerich-swatches-to-order";
    }

    if (!pageLink) return;

    upholsterySwatches.forEach(function (swatch) {

      const ul = swatch.querySelector(".swatch-single");

      if (!ul) return;

      // Prevent duplicate links
      if (swatch.querySelector(".view-all-vendor-swatches")) return;

     const wrapper = document.createElement("span");
      wrapper.className = "view-all-vendor-swatches";

      const link = document.createElement("a");
      link.href = pageLink;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.textContent = "View all";

      wrapper.appendChild(link);

      wrapper.appendChild(
        document.createTextNode(" " + vendor + " Swatches")
      );

      ul.insertAdjacentElement("afterend", wrapper);

    });

  }

  addVendorSwatchLinks();

  const observer = new MutationObserver(function () {
    addVendorSwatchLinks();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});